import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryCard = ({ category, onCategoryClick }) => {
  const handleClick = () => {
    onCategoryClick?.(category.slug);
  };

  return (
    <div 
      onClick={handleClick}
      className="group bg-white rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 cursor-pointer overflow-hidden border border-transparent hover:border-primary-200"
    >
      <div className="p-6 h-full flex flex-col">
        {/* Icon Section */}
        <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary-50 to-secondary-50 rounded-xl mb-4 group-hover:from-primary-100 group-hover:to-secondary-100 transition-all duration-300">
          <Icon 
            name={category.icon} 
            size={32} 
            color="#8B1538" 
            className="group-hover:scale-110 transition-transform duration-300"
          />
        </div>

        {/* Content Section */}
        <div className="flex-1 space-y-3">
          <h3 className="font-heading font-semibold text-lg text-text-primary group-hover:text-primary transition-colors duration-300 line-clamp-2">
            {category.title}
          </h3>
          
          <p className="text-text-secondary font-caption text-sm leading-relaxed line-clamp-3">
            {category.description}
          </p>
        </div>

        {/* Action Indicator */}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border-light">
          <span className="text-xs font-medium text-text-muted uppercase tracking-wide">
            Explore Options
          </span>
          <div className="flex items-center space-x-1 text-primary group-hover:text-primary-600 transition-colors duration-300">
            <Icon name="ArrowRight" size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;